// Employee/styles/WeekViewStyles.ts
export const styles = {
    wrapper: {
        display: "flex",
        backgroundColor: "none",
        color: "#fff",
        height: "100%",
        width: "100%",
        flexDirection: "column",
        overflow: "auto",
        "@media (max-width: 768px)": {
            fontSize: "0.9rem",
        },
    },
    scheduleContainer: {
        width: "100%",
        backgroundColor: "none",
        flexGrow: 1,
        userSelect: "none",
        overflowX: "auto",
    },
    table: {
        height: "100%",
        width: "100%",
        border: "none !important",
    },
    tableHeader: {
        maxWidth: "1rem",
        width: "100%",
    },
    timeRow: {
        borderBottom: "1px solid #444",
    },
    timeColumn: {
        backgroundColor: "none",
        color: "#ccc",
        textAlign: "right",
        border: "none!important",
        verticalAlign: "top",
        padding: "0",
        maxWidth: "1rem",
    },
    timeSlot: {
        color: "#ccc",
        fontWeight: "bold",
        borderBottom: "none!important",
        borderTop: "1px solid #444",
        padding: "0 0.5rem",
        "@media (max-width: 768px)": {
            padding: "0 0.25rem",
        },
    },
    timeSlotText: {
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        color: "#ccc",
        fontSize: "0.75rem",
        fontWeight: "bold",
        margin: 0,
        padding: "0",
        "@media (max-width: 768px)": {
            fontSize: "0.75rem",
        },
        "@media (max-width: 390px)": {
            fontSize: "0.65rem",
        },
    },
    dayHeader: {
        padding: "0.3rem",
        borderBottom: "none",
        textAlign: "center",
    },
    dayHeaderText: {
        fontSize: "0.8rem",
        "@media (max-width: 768px)": {
            fontSize: "0.8rem",
        },
        "@media (max-width: 390px)": {
            fontSize: "0.7rem",
        },
    },
    dayColumn: {
        border: "1px solid #444",
        padding: 0,
        maxWidth: "1rem",
        position: "relative",
        verticalAlign: "top",
        overflow: "visible",
        userSelect: "none",
        "&.selected": {
            backgroundColor: "rgba(144, 202, 249, 0.3)",
        },
        minHeight: "6rem",
        "@media (max-width: 768px)": {
            minHeight: "4rem",
        },
    },
    eventCard: {
        display: "flex",
        justifyContent: "space-between",
        overflow: "hidden",
        position: "absolute",
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        alignItems: "center",
        backgroundColor: "rgba(30, 30, 30, 0.7)",
        color: "#fff",
        padding: "0.5rem",
        zIndex: 10,
        height: "100%",
        boxShadow: "none",
        "@media (max-width: 768px)": {
            flexDirection: "column",
            padding: "0.20rem",
        },
    },
    eventButton: {
        backgroundColor: "rgba(107,191,255,0.78)",
        color: "#fff",
    },
    eventTimeContainer: {
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        gap: 0.5,
        height: "100%",
        width: "100%",
    },
    eventTitle: {
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        height: "100%",
        fontWeight: "bold",
        fontSize: "0.875rem",
        "@media (max-width: 768px)": {
            fontSize: "0.55rem",
        },
    },
    eventTime: {
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        fontSize: "0.75rem",
        "@media (max-width: 768px)": {
            fontSize: "0.65rem",
        },
        "@media (max-width: 490px)": {
            fontSize: "0.55rem",
        },
    },
    dragPreview: {
        position: "fixed",
        pointerEvents: "none",
        backgroundColor: "rgba(144, 202, 249, 0.8)",
        borderRadius: "4px",
        zIndex: 9999,
        transform: "translate(-50%, -50%)",
        whiteSpace: "nowrap",
    },
};
